<!-- <h1 mat-dialog-title>Hi {{data.name}}</h1> -->
<div mat-dialog-content class="dialog-content">
  <b >ARE YOU SURE<br> YOU WANT TO END THE CALL?</b>
</div>
<div mat-dialog-actions align="center">
  <button mat-raised-button mat-dialog-close>NO</button>
  <button mat-raised-button color="warn" cdkFocusInitial [mat-dialog-close]="true">YES</button>
</div>

